import { render, staticRenderFns } from "./EstimateHistory.vue?vue&type=template&id=460b300e&"
import script from "./EstimateHistory.vue?vue&type=script&lang=ts&"
export * from "./EstimateHistory.vue?vue&type=script&lang=ts&"
import style0 from "./EstimateHistory.vue?vue&type=style&index=0&id=460b300e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports